var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeoHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8 18.175h4.015v-6.128c0-.312.104-.573.312-.784.208-.21.466-.316.773-.316h4.2a1.072 1.072 0 0 1 1.085 1.1v6.128H16.2V7.415a.355.355 0 0 0-.04-.17.454.454 0 0 0-.11-.134L9.22 1.906A.32.32 0 0 0 9 1.825a.32.32 0 0 0-.22.081L1.95 7.111a.454.454 0 0 0-.11.135.355.355 0 0 0-.04.169v10.76zm-1.8 0V7.415a2.207 2.207 0 0 1 .868-1.759L7.698.44c.38-.293.813-.44 1.3-.44.488 0 .922.147 1.303.44l6.831 5.216A2.207 2.207 0 0 1 18 7.415v10.76c0 .498-.177.926-.532 1.286A1.72 1.72 0 0 1 16.2 20h-4.73c-.308 0-.566-.105-.773-.316a1.07 1.07 0 0 1-.313-.784v-6.128H7.616V18.9c0 .312-.104.573-.313.784-.207.21-.465.316-.772.316H1.8c-.49 0-.913-.18-1.268-.54A1.767 1.767 0 0 1 0 18.176z",
    fill: "#626266",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoHome);
export default __webpack_public_path__ + "static/media/geo-home.c70a3f6bfa59bd70a04a4ac50400a417.svg";
export { ForwardRef as ReactComponent };